'use strict';

var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var makeStyles = require('../../Styles/makeStyles.js');
var classNames = require('classnames');
var createStyles = require('../../../node_modules/@material-ui/core/esm/styles/createStyles.js');
var MenuItem = require('../../../node_modules/@material-ui/core/esm/MenuItem/MenuItem.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles = makeStyles["default"](function (theme) {
  return createStyles({
    sizeStyles: _objectSpread({
      minHeight: 40
    }, theme.typography.subtitle1),
    colorsForTheme: theme.palette.type === 'dark' ? {
      color: theme.palette.grey[400],
      '&:hover': {
        background: theme.palette.grey[900],
        color: theme.palette.grey[50]
      }
    } : {}
  });
});
var MenuItemBase = React.forwardRef(function (_ref, ref) {
  var classes = _ref.classes,
      _ref$version = _ref.version,
      version = _ref$version === void 0 ? '' : _ref$version,
      children = _ref.children,
      restProps = objectWithoutProperties(_ref, ["classes", "version", "children"]);

  var _useStyles = useStyles(),
      sizeStyles = _useStyles.sizeStyles,
      colorsForTheme = _useStyles.colorsForTheme;

  return React__default["default"].createElement(MenuItem["default"], _objectSpread({
    classes: classes,
    className: version === 'v2' ? classNames__default["default"](sizeStyles, colorsForTheme) : '',
    ref: ref
  }, restProps), children);
});

module.exports = MenuItemBase;
